import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { User } from '../app/models/user';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  /**
   * The currently logged-in user.  Its info is also cached as JSON in sessionStorage.
   */
  private user = null;

  constructor(private httpClient: HttpClient) {
  }

  /**
   * 
   */
  login(username: string, password: string) {
    return this.httpClient.get(environment.apiUrl + '/auth/login?username='
      + username + "&password=" + password);
  }

  /**
   * Store the current User object (in string form)
   * @param user This is what came from the API, with leading caps
   */
  storeUser(user: any) {
    const u = new User();
    u.FirstName = user.FirstName;
    u.LastName = user.LastName;
    u.UserName = user.UserName;
    u.ID = user.UserID;

    sessionStorage.setItem("currentUser", JSON.stringify(u));
  }

  logoutUser() {
    this.user = null;
    sessionStorage.removeItem("currentUser");
  }

  isAuthenticated() {
    return (this.getUser() !== null);
  }

  /**
   * Is the current user an admin?
   */
  isAdmin(): boolean {
    return this.getUser().UserName === 'natalie';
  }

  /**
   * Returns the currently authenticated user ID.  Or null.
   */
  getUser(): User {
    // lazily create the current user singleton from sessionStorage
    if (this.user === null) {
      const u = sessionStorage.getItem("currentUser");
      if (u === null) {
        return null;
      }
      this.user = JSON.parse(u);
    }

    return this.user;
  }
}
